module.exports = __webpack_public_path__ + "media/images/event/event-template-kz-098eeac3ff5be51cdca188680cb09dfb.png";